import t from "react";
import e from "prop-types";

var o = function (t) {
  function e(e) {
    if (t.call(this, e), !e.store) throw new Error("@picostate/react was not provided with a picostate store!");
    this.store = e.store, this.state = this.store.state, this.store.listen(this.setState.bind(this));
  }

  return t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)).constructor = e, e.prototype.getChildContext = function () {
    return {
      picostate: this.store
    };
  }, e.prototype.render = function () {
    var t = this.props.children;
    return t.pop ? t[0] : t;
  }, e;
}(t.Component);

function r(o) {
  return function (r) {
    function s(e, s) {
      var i = s.picostate;
      return t.createElement(r, Object.assign({}, e, o(i.state, e), {
        hydrate: i.hydrate
      }));
    }

    return s.contextTypes = {
      picostate: e.object.isRequired
    }, s;
  };
}

o.childContextTypes = {
  picostate: e.object.isRequired
};
export { o as Provider, r as connect };